import { memo, type PropsWithChildren } from "react";
import type { IbanXSProps } from "./types";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { getFormInputProps } from "util/forms";
import { AssetTextField } from "ui/atoms/TextField";
import { BankingFormField } from "../shared";

const IbanXS = ({
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    bootstrapData,
    children,
    ...restProps
}: PropsWithChildren<IbanXSProps>) => (
    <Box
        component='form'
        onSubmit={handleSubmit}
        autoComplete='off'
    >
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: {
                    xs: '1fr',
                    lg: 'repeat(2, 1fr)'
                },
                gap: 2
            }}
        >
            <TextField
                {...getFormInputProps(BankingFormField.BankId, restProps)}
                fullWidth
                required
                disabled
                size='small'
                name={BankingFormField.BankId}
                value={values[BankingFormField.BankId]}
                label='Bank ID'
                onChange={handleChange}
                onBlur={handleBlur}
            />
            <TextField
                {...getFormInputProps(BankingFormField.FullName, restProps)}
                fullWidth
                required
                size='small'
                name={BankingFormField.FullName}
                value={values[BankingFormField.FullName]}
                label='Full Name'
                onChange={handleChange}
                onBlur={handleBlur}
            />
            <TextField
                {...getFormInputProps(BankingFormField.BankGroup, restProps)}
                fullWidth
                size='small'
                name={BankingFormField.BankGroup}
                value={values[BankingFormField.BankGroup] || ''}
                label='Bank Group'
                onChange={handleChange}
                onBlur={handleBlur}
            />
            <AssetTextField
                {...getFormInputProps(BankingFormField.LogoUrl, restProps)}
                fullWidth
                inputProps={{
                    maxLength: 191
                }}
                size='small'
                name={BankingFormField.LogoUrl}
                value={values[BankingFormField.LogoUrl] || ''}
                label={`Logo URL (${bootstrapData.OpenBankingLogosDomain})`}
                onChange={handleChange}
                onBlur={handleBlur}
            />
        </Box>
        {children}
    </Box>
);

export default memo(IbanXS);
